import { createRootLocationForOtherConsumer, createRootLocationForPrimaryConsumer, createSearchParams, getConsumerPath, serializeSearchParams, } from '@feature-hub/history-service';
import * as history from 'history';
const consumerPathsQueryParamName = '---';
export function splitUrlInBaseAndPrimaryConsumer(path) {
    const isFullyQualifiedUrl = path.startsWith('http');
    let pathUsedForSplitting = path;
    let origin = undefined;
    if (isFullyQualifiedUrl) {
        const url = new URL(path);
        pathUsedForSplitting = url.pathname;
        origin = url.origin;
    }
    const splitPathname = pathUsedForSplitting.split(':');
    return {
        origin,
        primaryPathname: splitPathname && splitPathname[1] ? splitPathname[1] : '/',
        rootPathname: splitPathname && splitPathname[0] ? splitPathname[0] : '/',
    };
}
function checkIfConsumerIsSomewhereAPrimaryConsumer(consumerId, primaryConsumerId, splitPathname, navigationServiceConfig) {
    if (consumerId === primaryConsumerId) {
        return true;
    }
    if (navigationServiceConfig) {
        const currentRootUrl = splitPathname.origin
            ? new URL(splitPathname.rootPathname, splitPathname.origin).toString()
            : splitPathname.rootPathname;
        for (const pageKey of Object.keys(navigationServiceConfig.pages)) {
            for (const featureAppIds of Object.values(navigationServiceConfig.pages[pageKey].featureApps)) {
                if (navigationServiceConfig.pages[pageKey].path === currentRootUrl &&
                    consumerId === featureAppIds) {
                    return true;
                }
            }
        }
    }
    return false;
}
export function createRootLocationTransformer(integratorId, primaryConsumerId, navigationServiceConfig) {
    return {
        createNewRootLocationForMultipleConsumers(...consumerLocations) {
            let newRootLocation = {
                pathname: '/',
            };
            const integratorConsumer = consumerLocations.find((consumerLocations) => consumerLocations.historyKey === integratorId);
            if (integratorConsumer) {
                newRootLocation = this.createRootLocation(newRootLocation, integratorConsumer.location, integratorConsumer.historyKey);
            }
            consumerLocations
                .filter((consumerLocations) => consumerLocations.historyKey !== integratorId)
                .forEach((consumerLocation) => {
                newRootLocation = this.createRootLocation(newRootLocation, consumerLocation.location, consumerLocation.historyKey);
            });
            return newRootLocation;
        },
        createRootLocation: (currentRootLocation, consumerLocation, historyKey) => {
            if (historyKey === integratorId) {
                return Object.assign(Object.assign({}, consumerLocation), { hash: currentRootLocation.hash || consumerLocation.hash });
            }
            const splitPathname = splitUrlInBaseAndPrimaryConsumer(currentRootLocation.pathname || '');
            const consumerRootLocation = {
                hash: currentRootLocation.hash,
                pathname: splitPathname.primaryPathname,
                search: currentRootLocation.search,
            };
            const isPrimaryConsumer = checkIfConsumerIsSomewhereAPrimaryConsumer(historyKey, primaryConsumerId, splitPathname, navigationServiceConfig);
            let newRootLocation;
            if (isPrimaryConsumer) {
                newRootLocation = createRootLocationForPrimaryConsumer(consumerRootLocation, Object.assign(Object.assign({}, consumerLocation), { hash: consumerLocation.hash || currentRootLocation.hash }), consumerPathsQueryParamName);
            }
            else {
                newRootLocation = createRootLocationForOtherConsumer(consumerRootLocation, consumerLocation, historyKey, consumerPathsQueryParamName);
            }
            const url = new URL(splitPathname.rootPathname +
                (newRootLocation.pathname !== '/'
                    ? `:${newRootLocation.pathname}`
                    : ''), splitPathname.origin || 'http://localhost');
            return Object.assign(Object.assign({}, newRootLocation), { pathname: splitPathname.origin ? url.toString() : url.pathname });
        },
        getConsumerPathFromRootLocation: (rootLocation, historyKey) => {
            const splitPathname = splitUrlInBaseAndPrimaryConsumer(rootLocation.pathname || '');
            if (historyKey === integratorId) {
                const testPath = history.createPath({
                    hash: undefined,
                    pathname: splitPathname.rootPathname,
                    search: rootLocation.search,
                });
                return testPath;
            }
            const newLocation = {
                hash: rootLocation.hash,
                pathname: splitPathname.primaryPathname,
                search: rootLocation.search,
            };
            const isPrimaryConsumer = primaryConsumerId === historyKey;
            const searchParams = createSearchParams(newLocation);
            if (isPrimaryConsumer) {
                searchParams.delete(consumerPathsQueryParamName);
                const { pathname, hash } = newLocation;
                const search = serializeSearchParams(searchParams);
                const testPath = history.createPath({
                    hash,
                    pathname,
                    search,
                });
                return testPath;
            }
            const consumerPaths = searchParams.get(consumerPathsQueryParamName);
            if (!consumerPaths) {
                return '/';
            }
            const consumerPath = getConsumerPath(consumerPaths, historyKey) || '/';
            return consumerPath;
        },
    };
}
//# sourceMappingURL=history-service-transformer.js.map